<div mat-dialog-title class="dialog-info p-0 m-0" closeOnEscape>
    <label class="dialogTitle horizontal-padding">
        {{'PROPERTIES_PROPOSAL_ADVANCED_OPTIONS' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none dialogCross horizontal-padding" [mat-dialog-close]></button>
</div>
<mat-dialog-content [formGroup]="advancedOptionsForm" class="horizontal-padding content-overflow">
    <div class="row m-0">
        <div class="col-sm-6 p-0">
            <fieldset>
                <legend>
                    {{'PROPERTIES_PROPOSAL_ADVANCED_OPTIONS_USER_DEFINED' | translate}}
                </legend>
                <div class="row m-0">
                    <label class="horizontal-padding">
                        {{'PROPERTIES_PROPOSAL_ADVANCED_OPTIONS_ENTER_USER_DEFINED' | translate}}
                    </label>
                </div>
                <div class="row m-0 align-items-center">
                    <div class="col-sm-7 p-0">
                        <mat-checkbox color="primary" formControlName="projectManagerLaborCheckbox"
                            (change)="onCheckboxToggle('projectManagerLaborCheckbox', 'projectManagerLabor')">{{'PROPERTIES_PROPOSAL_ADVANCED_OPTIONS_PROJECT_MANAGER_LABOR'| translate }}
                        </mat-checkbox>
                    </div>
                    <div class="col-sm-5 p-0">
                        <mat-form-field appearance="outline" class="col-sm-12 full-width align-input-fields">
                            <input matInput formControlName="projectManagerLabor" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row m-0 align-items-center">
                    <div class="col-sm-7 p-0">
                        <mat-checkbox color="primary" formControlName="engineerLaborCheckbox"
                            (change)="onCheckboxToggle('engineerLaborCheckbox', 'engineerLabor')">
                            {{'PROPERTIES_PROPOSAL_ADVANCED_OPTIONS_ENGINEERING_LABOR' | translate }}
                        </mat-checkbox>
                    </div>
                    <div class="col-sm-5 p-0">
                        <mat-form-field appearance="outline" class="col-sm-12 full-width align-input-fields">
                            <input matInput formControlName="engineerLabor" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row m-0 align-items-center">
                    <div class="col-sm-7 p-0">
                        <mat-checkbox color="primary" formControlName="cyberSecurityEngineerLaborCheckbox"
                            (change)="onCheckboxToggle('cyberSecurityEngineerLaborCheckbox', 'cyberSecurityEngineerLabor')">{{'CYBER_SECURITY_ENGINEER_LABOR' | translate }}
                        </mat-checkbox>
                    </div>
                    <div class="col-sm-5 p-0">
                        <mat-form-field appearance="outline" class="col-sm-12 full-width align-input-fields">
                            <input matInput formControlName="cyberSecurityEngineerLabor" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row m-0 align-items-center">
                    <div class="col-sm-7 p-0">
                        <mat-checkbox color="primary" formControlName="energyEngineerLaborCheckbox"
                            (change)="onCheckboxToggle('energyEngineerLaborCheckbox', 'energyEngineerLabor')">{{'ENERGY_ENGINEER_LABOR' | translate }}
                        </mat-checkbox>
                    </div>
                    <div class="col-sm-5 p-0">
                        <mat-form-field appearance="outline" class="col-sm-12 full-width align-input-fields">
                            <input matInput formControlName="energyEngineerLabor" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row m-0 align-items-center">
                    <div class="col-sm-7 p-0">
                        <mat-checkbox color="primary" formControlName="electricEngineerLaborCheckbox"
                            (change)="onCheckboxToggle('electricEngineerLaborCheckbox', 'electricEngineerLabor')">{{'ELECTRICAL_ENGINEER_LABOR' | translate }}
                        </mat-checkbox>
                    </div>
                    <div class="col-sm-5 p-0">
                        <mat-form-field appearance="outline" class="col-sm-12 full-width align-input-fields">
                            <input matInput formControlName="electricEngineerLabor" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row m-0 align-items-center">
                    <div class="col-sm-7 p-0">
                        <mat-checkbox color="primary" formControlName="networkEngineerLaborCheckbox"
                            (change)="onCheckboxToggle('networkEngineerLaborCheckbox', 'networkEngineerLabor')">{{'NETWORK_ENGINEER_LABOR' | translate }}
                        </mat-checkbox>
                    </div>
                    <div class="col-sm-5 p-0">
                        <mat-form-field appearance="outline" class="col-sm-12 full-width align-input-fields">
                            <input matInput formControlName="networkEngineerLabor" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row m-0 align-items-center">
                    <div class="col-sm-7 p-0">
                        <mat-checkbox color="primary" formControlName="qualificationEngineerLaborCheckbox"
                            (change)="onCheckboxToggle('qualificationEngineerLaborCheckbox', 'qualificationEngineerLabor')">{{'QUALIFICATION_ENGINEER_LABOR' | translate }}
                        </mat-checkbox>
                    </div>
                    <div class="col-sm-5 p-0">
                        <mat-form-field appearance="outline" class="col-sm-12 full-width align-input-fields">
                            <input matInput formControlName="qualificationEngineerLabor" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row m-0 align-items-center">
                    <div class="col-sm-7 p-0">
                        <mat-checkbox color="primary" formControlName="graphicCheckbox"
                            (change)="onCheckboxToggle('graphicCheckbox', 'graphic')">
                            {{'GRAPHIC' | translate}}
                        </mat-checkbox>
                    </div>
                    <div class="col-sm-5 p-0">
                        <mat-form-field appearance="outline" class="col-sm-12 full-width align-input-fields">
                            <input matInput formControlName="graphic" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row m-0 align-items-center">
                    <div class="col-sm-7 p-0">
                        <mat-checkbox color="primary" formControlName="programmingCheckbox"
                            (change)="onCheckboxToggle('programmingCheckbox', 'programming')">
                            {{'PROGRAMMING' | translate}}
                        </mat-checkbox>
                    </div>
                    <div class="col-sm-5 p-0">
                        <mat-form-field appearance="outline" class="col-sm-12 full-width align-input-fields">
                            <input matInput formControlName="programming" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row m-0 align-items-center">
                    <div class="col-sm-7 p-0">
                        <mat-checkbox color="primary" formControlName="specialistLaborCheckbox"
                            (change)="onCheckboxToggle('specialistLaborCheckbox', 'specialistLabor')">
                            {{'PROPERTIES_PROPOSAL_ADVANCED_OPTIONS_SPECIALIST_LABOR' | translate}}
                        </mat-checkbox>
                    </div>
                    <div class="col-sm-5 p-0">
                        <mat-form-field appearance="outline" class="col-sm-12 full-width align-input-fields">
                            <input matInput formControlName="specialistLabor" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row m-0 align-items-center">
                    <div class="col-sm-7 p-0">
                        <mat-checkbox color="primary" formControlName="ddsCheckbox"
                            (change)="onCheckboxToggle('ddsCheckbox', 'dds')">
                            {{'DDS' | translate}}
                        </mat-checkbox>
                    </div>
                    <div class="col-sm-5 p-0">
                        <mat-form-field appearance="outline" class="col-sm-12 full-width align-input-fields">
                            <input matInput formControlName="dds" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row m-0 align-items-center">
                    <div class="col-sm-7 p-0">
                        <mat-checkbox color="primary" formControlName="mechanicalLaborCheckbox"
                            (change)="onCheckboxToggle('mechanicalLaborCheckbox', 'mechanicalLabor')">
                            {{'PROPERTIES_PROPOSAL_ADVANCED_OPTIONS_MECHANICAL_LABOR' | translate}}
                        </mat-checkbox>
                    </div>
                    <div class="col-sm-5 p-0">
                        <mat-form-field appearance="outline" class="col-sm-12 full-width align-input-fields">
                            <input matInput formControlName="mechanicalLabor" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row m-0 align-items-center">
                    <div class="col-sm-7 p-0">
                        <mat-checkbox color="primary" formControlName="electricalLaborCheckbox"
                            (change)="onCheckboxToggle('electricalLaborCheckbox', 'electricalLabor')">
                            {{'PROPERTIES_PROPOSAL_ADVANCED_OPTIONS_ELECTRICAL_LABOR' | translate}}
                        </mat-checkbox>
                    </div>
                    <div class="col-sm-5 p-0">
                        <mat-form-field appearance="outline" class="col-sm-12 full-width align-input-fields">
                            <input matInput formControlName="electricalLabor" />
                        </mat-form-field>
                    </div>
                </div>
                <hr class="m-0">
                @if (isMechanicalFeeVisible) {
                    <div class="row m-0 align-items-center">
                        <div class="col-sm-7 p-0">
                            <mat-checkbox color="primary" formControlName="mechanicalFeeCheckbox"
                                (change)="onCheckboxToggle('mechanicalFeeCheckbox', 'mechanicalFee')">
                                {{'MECHANICAL_FEE' | translate}}
                            </mat-checkbox>
                        </div>
                        <div class="col-sm-5 p-0">
                            <mat-form-field appearance="outline" class="col-sm-12 full-width align-input-fields">
                                <input matInput formControlName="mechanicalFee" />
                            </mat-form-field>
                        </div>
                    </div>
                }
                <div class="row m-0 align-items-center">
                    <div class="col-sm-7 p-0">
                        <mat-checkbox color="primary" formControlName="productivityReserveCheckbox"
                            (change)="onCheckboxToggle('productivityReserveCheckbox', 'productivityReserve')">
                            {{'PRODUCTIVITY_RESERVE' | translate}}
                        </mat-checkbox>
                    </div>
                    <div class="col-sm-5 p-0">
                        <mat-form-field appearance="outline" class="col-sm-12 full-width align-input-fields">
                            <input matInput formControlName="productivityReserve" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row m-0 align-items-center">
                    <div class="col-sm-7 p-0">
                        <mat-checkbox color="primary" formControlName="riskCheckbox"
                            (change)="onCheckboxToggle('riskCheckbox', 'risk')">
                            {{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_RISK' | translate}}
                        </mat-checkbox>
                    </div>
                    <div class="col-sm-5 p-0">
                        <mat-form-field appearance="outline" class="col-sm-12 full-width align-input-fields">
                            <input matInput formControlName="risk" />
                        </mat-form-field>
                    </div>
                </div>
                @if (isSubcontractorFeeVisible) {
                    <div class="row m-0 align-items-center">
                        <div class="col-sm-7 p-0">
                            <mat-checkbox color="primary" formControlName="subcontractorFeeCheckbox"
                                (change)="onCheckboxToggle('subcontractorFeeCheckbox', 'subcontractorFee')">
                                {{'PROPERTIES_PROPOSAL_ADVANCED_OPTIONS_SUBCONTRACTOR_FEE' | translate}}
                            </mat-checkbox>
                        </div>
                        <div class="col-sm-5 p-0">
                            <mat-form-field appearance="outline" class="col-sm-12 full-width align-input-fields">
                                <input matInput formControlName="subcontractorFee" />
                            </mat-form-field>
                        </div>
                    </div>
                }               
                <div class="row m-0 align-items-center">
                    <div class="col-sm-7 p-0">
                        <mat-checkbox color="primary" formControlName="technologyCheckbox"
                            (change)="onCheckboxToggle('technologyCheckbox', 'technology')">
                            {{'PROPERTIES_PROPOSAL_ADVANCED_OPTIONS_TECHNOLOGY_FEE' | translate}}
                        </mat-checkbox>
                    </div>
                    <div class="col-sm-5 p-0">
                        <mat-form-field appearance="outline" class="col-sm-12 full-width align-input-fields">
                            <input matInput formControlName="technology" />
                        </mat-form-field>
                    </div>
                </div>
            </fieldset>
        </div>
        <div class="col-sm-6 horizontal-padding pe-0">
            <div class="row m-0">
                <div class="col-sm-12 p-0">
                    <fieldset>
                        <legend>
                            {{'PROPERTIES_PROPOSAL_ADVANCED_OPTIONS_DISTRIBUTE_TOP_LEVEL_COSTS' | translate}}
                        </legend>
                        <div class="row m-0">
                            <div class="col-sm-4 d-flex p-0 align-items-center">
                                <mat-radio-group formControlName="distributeTopLevelCostsOption"
                                    (change)="onDistributeTopLevelToggle()">
                                    <mat-radio-button color="primary" [value]="false">
                                        {{'NO' | translate}}
                                    </mat-radio-button>
                                    <mat-radio-button color="primary" [value]="true">
                                        {{'YES' | translate}}
                                    </mat-radio-button>
                                </mat-radio-group>
                            </div>
                            <div class="col-sm-8 p-0">
                                <mat-radio-group formControlName="distributedTopLevelOptions"
                                    (change)="onDistributedTopLevelOptionToggle()">
                                    <div class="row m-0">
                                        <mat-radio-button  class="p-0" color="primary"
                                            [value]="0">
                                            {{'PROPERTIES_PROPOSAL_ADVANCED_OPTIONS_SPECIFIC_BY_PERCENTAGE' | translate}}
                                        </mat-radio-button>
                                    </div>
                                    <div class="row m-0">
                                        <mat-radio-button  class="p-0" color="primary"
                                            [value]="1">
                                            {{'PROPERTIES_PROPOSAL_ADVANCED_OPTIONS_MOVE_TO_AREA' | translate}}
                                        </mat-radio-button>
                                    </div>
                                </mat-radio-group>
                            </div>
                        </div>
                        <div class="row m-0 justify-content-end">
                            <div class="col-sm-7 horizontal-padding">
                                <mat-form-field appearance="outline" class="col-sm-12 full-width">
                                    <mat-select formControlName="areaSelectionForTopLevelCosts">
                                        @for(area of areas; track area.id){
                                            <mat-option [value]="area.id">
                                            {{ area.description }}
                                        </mat-option>
                                        }
                                        
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </fieldset>
                </div>
                <div class="col-sm-12 p-0">
                    <fieldset>
                        <legend>
                            {{'UNLINK_PROPOSAL' | translate}}
                        </legend>
                        <div class="row align-items-center text-align-left m-0">
                            <label class="p-0">
                                {{'UNLINK_PROPOSAL_MESSAGE' | translate}}
                            </label>
                        </div>
                        <div class="row col-sm-4 align-items-center m-0 vertical-padding">
                            <button mat-raised-button color="primary" [disabled]="!isProposalCanBeUnlinked" (click)="onUnlinkProposalClick()">
                                {{'UNLINK_PROPOSAL' | translate}}
                            </button>
                        </div>
                        <div class="row align-items-start m-0">
                            <label class="col-sm-3 p-0">
                                {{'PROPOSAL_LINK' | translate}}:
                            </label>
                            <div class="col-sm-9 p-0 text-break">
                                <a [href]="proposalLink.value" target="_blank" rel="noopener noreferrer">{{ proposalIdControl.value }}</a>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>
    </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button color="primary" (click)="onOkClick()">
        {{'OK' | translate}}
    </button>
    <button mat-button color="warn" mat-dialog-close>
        {{'CANCEL' | translate}}
    </button>
</mat-dialog-actions>